import n from '../../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-editor .selection-anchor{background-color:#007acc;width:2px!important}";
n(css,{});
export { css, css as default };
